
import { Component } from '@angular/core';
import { NotificacionesComponent } from '../General/notificaciones.component';

@Component({
    selector: 'oaj-notificacion-itx',
    templateUrl: 'electronicNotification.component.html',
    styleUrls: ['electronicNotification.component.css'],
    imports: [NotificacionesComponent]
})
export class ElectronicNotificationComponent { }
